import { instance } from "libs/api";

import { ApiRoutesEarnings } from "../../constants";

export const requestPayAllEarnings = async (): Promise<void> => {
  return await instance.patch(ApiRoutesEarnings.PayAllEarnings);
};
